import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {AppSettingsTrainingPage} from "../app-settings-training/app-settings-training";

/**
 * Generated class for the AppSettingsTrainingPopupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-settings-training-popup',
  templateUrl: 'app-settings-training-popup.html',
})
export class AppSettingsTrainingPopupPage extends AppSettingsTrainingPage{


}



// WEBPACK FOOTER //
// ./src/pages/app-settings-training-popup/app-settings-training-popup.ts